
import { Component, Vue ,Provide,Watch} from 'vue-property-decorator';
@Component
export default class SwitchBreadCrumb extends Vue {
    
    $router: any;
    $message: any;

       @Provide() breadCrumbName?: string="操作页面";
       @Provide() breadCrumbPath?: any="/Welcome";
       @Provide() returnPath?: any="/Welcome";

    @Watch('$route')
    watchContent(to: any,from: any): void{
        this.returnPath = from.path;
        this.breadCrumbPath = to.path;
        this.breadCrumbName= to.name;      
    }

    clickChildBreadCrumb(): void{
        this.$message({
            showClose: true,
            message: '已在此页面！',
        });
        this.$emit('switch');  //调用父组件刷新菜单样式
    }

    clickBreadCrumb(mainPath: string){
        if(mainPath!=this.breadCrumbPath)
        {
            this.$router.push(mainPath);
             this.$emit('switch');  //调用父组件刷新菜单样式
            // this.$message({
            //             showClose: true,
            //             message: '已跳转至主页！',
            //             type: 'success'
            //         });
           
        }
        else
        {
            this.clickChildBreadCrumb();
        }
    }


    previous(): void{

        if(this.breadCrumbPath!=this.returnPath)
        {
            this.$router.go(-1);            
            this.$emit('switch');  //调用父组件刷新菜单样式
            // this.$message({
            //                 showClose: true,
            //                 message: '返回上一页',
            //                 type: 'success'
            //             });
            
        }
        else{
            //  this.$message({
            //     showClose: true,
            //     message: '当前为第一页',
            // });
        }
    }
}

